import { ScheduledBlock } from '../../../../../types/ScheduledBlock';

export const getBlockId = (block: ScheduledBlock) => block.intent?.id ?? `${block.start}`;
